export const WHITE_COLOR_RGB = [255, 255, 255];
